import axiosInstance from '../../lib/api/axios';
import { getServerUrl } from '../../lib/utils';
import { Entry, EntryContent } from './types';

export const createEntry = async (databaseSlug: string, tableSlug: string, content: EntryContent): Promise<Entry> => {
  const { data } = await axiosInstance.post(`${getServerUrl()}/${databaseSlug}/${tableSlug}`, content);
  return data;
};

export const updateEntry = async (
  databaseSlug: string,
  tableSlug: string,
  uuid: string,
  content: EntryContent,
): Promise<Entry> => {
  const { data } = await axiosInstance.put(`${getServerUrl()}/${databaseSlug}/${tableSlug}/${uuid}`, content);
  return data;
};

export const deleteEntry = async (databaseSlug: string, tableSlug: string, uuid: string): Promise<void> => {
  await axiosInstance.delete(`${getServerUrl()}/${databaseSlug}/${tableSlug}/${uuid}`);
};
